import { LocalNotifications, PermissionStatus } from '@capacitor/local-notifications'

export const checkLocalNotificationPermissions = async (): Promise<PermissionStatus> => {
  return await LocalNotifications.checkPermissions()
}

export const promptForLocalNotificationPermission = async (): Promise<PermissionStatus> => {
  return await LocalNotifications.requestPermissions()
}

export const clearLocalNotifications = async (): Promise<void> => {
  const pending = await LocalNotifications.getPending()
  const notificationsToClear = pending.notifications.map((pendingNotification) => {
    return { id: pendingNotification.id }
  })

  LocalNotifications.cancel({
    notifications: notificationsToClear,
  })
}
